(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[84059,19341,97,84045],{

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 91175:
/***/ (function(module) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),

/***/ 13217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259);

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

module.exports = tail;


/***/ }),

/***/ 84059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Common_Table; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./components/Layout/FullLayout/index.jsx
var FullLayout = __webpack_require__(22116);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/lodash/head.js
var head = __webpack_require__(91175);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/tail.js
var tail = __webpack_require__(13217);
var tail_default = /*#__PURE__*/__webpack_require__.n(tail);
// EXTERNAL MODULE: ./components/Common/Table/styles.module.scss
var styles_module = __webpack_require__(37599);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/Table/SimpleTableBody/index.jsx



var SimpleTableBody = function(param) {
    var tableData = param.tableData;
    if (!tableData) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
        children: tableData.map(function(row) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                className: (styles_module_default()).tableRow,
                children: row.map(function(cell) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: (styles_module_default()).tableHeader,
                        children: cell
                    });
                })
            });
        })
    });
};
SimpleTableBody.propTypes = {
    tableData: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var Table_SimpleTableBody = (SimpleTableBody);

;// CONCATENATED MODULE: ./components/Common/Table/SimpleTableHead/index.jsx



var SimpleTableHead = function(param) {
    var tableHeader = param.tableHeader;
    if (!tableHeader) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
            className: (styles_module_default()).tableRow,
            children: tableHeader && tableHeader.map(function(cell) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    className: (styles_module_default()).tableHeader,
                    scope: "col",
                    children: cell
                });
            })
        })
    });
};
SimpleTableHead.propTypes = {
    tableHeader: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var Table_SimpleTableHead = (SimpleTableHead);

// EXTERNAL MODULE: ./components/Common/Table/TableContent/styles.module.scss
var TableContent_styles_module = __webpack_require__(33197);
var TableContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(TableContent_styles_module);
;// CONCATENATED MODULE: ./components/Common/Table/TableContent/index.jsx








var TableContent = function(param) {
    var tableData = param.tableData, type = param.type;
    switch(type){
        case constants/* ARTICLE_TABLE_TYPES.simpleTable */.BP.simpleTable:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                className: (TableContent_styles_module_default()).table,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SimpleTableBody, {
                    tableData: tableData
                })
            });
        case constants/* ARTICLE_TABLE_TYPES.tableWithHeader */.BP.tableWithHeader:
            var tableHeader = head_default()(tableData);
            var tableCells = tail_default()(tableData);
            if (!tableHeader || !tableCells) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: (TableContent_styles_module_default()).table,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SimpleTableHead, {
                        tableHeader: tableHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SimpleTableBody, {
                        tableData: tableCells
                    })
                ]
            });
        case constants/* ARTICLE_TABLE_TYPES.tableWithTwoHeader */.BP.tableWithTwoHeader:
            var tableFirstHeader = head_default()(tableData);
            var tableCellsData = tail_default()(tableData);
            if (!tableFirstHeader || !tableCellsData) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: (TableContent_styles_module_default()).table,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SimpleTableHead, {
                        tableHeader: tableFirstHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: tableCellsData && tableCellsData.map(function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                className: (TableContent_styles_module_default()).tableRow,
                                children: row.map(function(cell, index) {
                                    return index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (TableContent_styles_module_default()).tableVerticalHeader,
                                        children: cell
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (TableContent_styles_module_default()).tableHeader,
                                        children: cell
                                    });
                                })
                            });
                        })
                    })
                ]
            });
        default:
            return null;
    }
};
TableContent.defaultProps = {
    type: constants/* ARTICLE_TABLE_TYPES.simpleTable */.BP.simpleTable
};
TableContent.propTypes = {
    tableData: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/Common/Table/index.jsx








var Table = function(param) {
    var tableData = param.tableData, type = param.type;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    if (!tableData) {
        return null;
    }
    return isMobileResolution ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FullLayout/* default */.Z, {
        disableMaxWidth: true,
        disableTopPadding: true,
        disableSidePadding: true,
        disableBottomPadding: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).tableContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContent, {
                tableData: tableData,
                type: type
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContent, {
        tableData: tableData,
        type: type
    });
};
Table.defaultProps = {
    type: constants/* ARTICLE_TABLE_TYPES.simpleTable */.BP.simpleTable
};
Table.propTypes = {
    tableData: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};
/* harmony default export */ var Common_Table = (Table);


/***/ }),

/***/ 22116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(321);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);





var FullLayout = function(param) {
    var children = param.children, disableMaxWidth = param.disableMaxWidth, disableTopPadding = param.disableTopPadding, disableSidePadding = param.disableSidePadding, disableBottomPadding = param.disableBottomPadding, disableOverflowHiding = param.disableOverflowHiding, backgroundColor = param.backgroundColor, introSection = param.introSection, className = param.className;
    var _obj;
    var layoutStyles = classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullLayout), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[backgroundColor], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableMaxWidth), disableMaxWidth), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableTopPadding), disableTopPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableSidePadding), disableSidePadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableBottomPadding), disableBottomPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableOverflowHiding), disableOverflowHiding), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: layoutStyles,
        ref: introSection,
        children: children
    });
};
FullLayout.defaultProps = {
    children: {},
    disableMaxWidth: false,
    disableTopPadding: false,
    disableSidePadding: false,
    disableBottomPadding: false,
    backgroundColor: "",
    introSection: null
};
FullLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object),
    disableMaxWidth: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableTopPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableSidePadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableBottomPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    introSection: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["Z"] = (FullLayout);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 33197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__vTj_o","table":"styles_table__Xc2je","tableVerticalHeader":"styles_tableVerticalHeader__ZCehY"};

/***/ }),

/***/ 37599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__p3wlW"};

/***/ }),

/***/ 321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullLayout":"styles_fullLayout__pin3O","disableOverflowHiding":"styles_disableOverflowHiding__LcGJo","disableMaxWidth":"styles_disableMaxWidth__V_d1K","disableSidePadding":"styles_disableSidePadding__Ybgq_","disableTopPadding":"styles_disableTopPadding__PX_CS","disableBottomPadding":"styles_disableBottomPadding__8xmaX","alabaster":"styles_alabaster__keXtu"};

/***/ })

}]);